import * as React from 'react'
import * as PropTypes from 'prop-types'
import { css } from 'glamor'
import { isElement } from '../../utils'

interface IListProps {
  children?: React.ReactNode
  toggleOpen?: (open: boolean) => void
}

class List extends React.Component<IListProps> {
  static propTypes = {
    children: PropTypes.node,
    toggleOpen: PropTypes.func,
  }

  render() {
    const { toggleOpen, children } = this.props

    return (
      <ul {...css({ padding: 0, margin: 0 })}>
        {React.Children.toArray(children).map(child =>
          isElement(child)
            ? React.cloneElement(child, {
                onClick: (event: React.SyntheticEvent, hide = true) => {
                  if (child.props.onClick) child.props.onClick(event)
                  if (hide && toggleOpen) toggleOpen(false)
                },
              })
            : child
        )}
      </ul>
    )
  }
}

export default List
